import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { Cobrar } from './Cobrar';
import { CobroCxC } from './CobroCxC';
import { Devolucion } from './Devolucion';
import { List } from './List';
import { View } from './View';

function PvDocumentos({ match }) {
    const { path } = match;

    return (
        <Switch>
            <Route exact path={path} component={List} />
            <Route path={`${path}/ver/:id`} component={View} />
            <Route path={`${path}/cobrar/:id`} component={Cobrar} />
            <Route path={`${path}/devolucion/:id`} component={Devolucion} />
            <Route path={`${path}/cobrocxc`} component={CobroCxC} />
            <Redirect from="*" to={path} />
        </Switch>
    );
}

export { PvDocumentos };
